export default "__VITE_ASSET__D0gI8VXj__"